'use client';
import type { ReactElement } from 'react';
import Link from 'next/link';

export default function SearchList({
  data,
  setSearchInput,
}: CardProps): ReactElement {
  return (
    <div className="flex flex-col gap-3 pb-4 pt-4 text-black">
      {data &&
        data.map((item, index) => (
          <div key={index} data-art={item.article}>
            <Link
              href={`/catalog/${item.sex}/${item.category}/${item.article?.trim()}`}
              onClick={() => setSearchInput && setSearchInput('')}
            >
              <p className="text-xl">{`${item.brand} ${item.name}`}</p>
            </Link>
          </div>
        ))}
    </div>
  );
}
